var map = {
	"./0.jpg": 6706,
	"./0.webp": 97709,
	"./1.jpg": 79408,
	"./1.webp": 21408,
	"./10.jpg": 97746,
	"./10.webp": 77920,
	"./2.jpg": 63950,
	"./2.webp": 17502,
	"./3.jpg": 4706,
	"./3.webp": 6069,
	"./4.jpg": 79248,
	"./4.webp": 30181,
	"./5.jpg": 44597,
	"./5.webp": 52568,
	"./6.jpg": 8227,
	"./6.webp": 79097,
	"./7.jpg": 99404,
	"./7.webp": 95814,
	"./8.jpg": 59181,
	"./8.webp": 73496,
	"./9.jpg": 3978,
	"./9.webp": 2739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38382;